/**
 * Sample biomarker breakdown shown on the report mockups (the "89 Biomarker →
 * 12 optimal / 73 im Normbereich / 4 außerhalb" tile on /report and the iPad
 * mockup on the blood LPs). Illustrative figures, not product data, but the
 * three counts must sum to the headline total.
 *
 * The total comes from `report.mockupBiomarkerTotal`. On de-DE that message is
 * `%panelCount%`, so the German sample matches the Vorsorge-Starter panel the
 * page sells and follows the CMS tag; every other catalog carries 89. The
 * optimal and out-of-range counts stay fixed and "in range" takes the rest.
 */
const OPTIMAL = 12
const OUT_OF_RANGE = 4
const DEFAULT_TOTAL = 89

export interface ReportMockupSample {
  total: number
  optimal: number
  inRange: number
  outOfRange: number
}

/** Breakdown for the translated `report.mockupBiomarkerTotal` value. */
export function reportMockupSample(totalLabel: string): ReportMockupSample {
  const parsed = Number.parseInt(totalLabel, 10)
  const total =
    Number.isFinite(parsed) && parsed > OPTIMAL + OUT_OF_RANGE
      ? parsed
      : DEFAULT_TOTAL
  return {
    total,
    optimal: OPTIMAL,
    inRange: total - OPTIMAL - OUT_OF_RANGE,
    outOfRange: OUT_OF_RANGE,
  }
}
